import { ReactNode } from "react";
import { colors } from "utils/constants";

export const Alignment = {
  LEFT: "LEFT",
  RIGHT: "RIGHT",
};

interface IZigzagFeatureProps {
  alignment: string;
  children: ReactNode;
  imageComponent: ReactNode;
  lightOnDark?: boolean;
}

export const ZigzagFeature = ({
  alignment,
  children,
  imageComponent,
  lightOnDark = false,
}: IZigzagFeatureProps) => (
  <div
    className={`feature${
      alignment === Alignment.RIGHT ? " rightAligned" : " leftAligned"
    }${lightOnDark ? " lightOnDark" : ""}`}
  >
    <div className="imageContainer">{imageComponent}</div>

    {children}

    <style jsx>{`
      .feature {
        display: flex;
        flex-direction: column;
        max-width: 300px;
        margin: 1em 0;
        flex: 1;
      }

      .imageContainer {
        height: 60px;
        width: 100%;
        display: flex;
        align-items: center;
      }

      .feature.rightAligned .imageContainer {
        justify-content: flex-end;
      }

      :global(.feature p) {
        font-weight: 600;
        font-size: 1.1em;
      }

      :global(.feature.lightOnDark p) {
        color: white;
      }

      :global(.feature h4) {
        margin-top: 10px;
        color: ${colors.primaryBrandGray};
      }

      :global(.feature.lightOnDark h4) {
        color: ${colors.brand.neon};
      }

      .feature.leftAligned {
        align-items: flex-start;
        align-self: flex-start;
      }

      .feature.rightAligned {
        align-items: flex-end;
        align-self: flex-end;
      }

      :global(.feature.leftAligned > p, .feature.leftAligned > h4) {
        text-align: left;
      }

      :global(.feature.rightAligned > p, .feature.rightAligned > h4) {
        text-align: right;
      }

      @media (min-width: 700px) {
        .feature {
          margin: 1em;
          align-self: flex-start !important;
        }

        :global(
            .feature.rightAligned,
            .feature.rightAligned > p,
            .feature.rightAligned > h4
          ) {
          align-items: flex-start !important;
          text-align: left;
        }

        .feature.rightAligned .imageContainer {
          justify-content: flex-start;
          align-items: center;
        }
      }
    `}</style>
  </div>
);

interface IZigzagFeatureListProps {
  children: ReactNode;
  style?: React.CSSProperties;
}

const ZigzagFeatureList = ({ children, style }: IZigzagFeatureListProps) => (
  <div className="featureContainer" style={style}>
    {children}

    <style jsx>{`
      .featureContainer {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 2em 2em;
      }

      @media (min-width: 400px) {
        .featureContainer {
          padding: 2em 3em;
        }
      }

      @media (min-width: 700px) {
        .featureContainer {
          max-width: 1200px;
          flex-direction: row;
          justify-content: space-around;
        }
      }
    `}</style>
  </div>
);

export default ZigzagFeatureList;
